import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../components/footer/footer';
import { Box } from '@chakra-ui/react';
import Sidebar from '../components/sidebar/sidebar';
import Header from '../components/header/header';
const MainLayout: React.FC = () => {
  return (
    <Box as="main">
      <Header />
      
      {/* <Sidebar /> */}
      {/* <Footer /> */}
      {/* <Box as="main" p={4}> */}
      <Box as="main">
        <Outlet />
      </Box>
      {/* <Footer /> */}
    </Box>
  );
};

export default MainLayout;
